<template>
  <div class="admin-layout">
    <!-- Sidebar -->
    <aside class="admin-sidebar" :class="{ collapsed: sidebarCollapsed }">
      <div class="logo">
        <template v-if="!sidebarCollapsed">
          <img src="/logo.svg" alt="" class="logo-img">
          <span>Car Admin</span>
        </template>
        <span v-else>CA</span>
      </div>

      <el-menu
        :default-active="activeMenu"
        :collapse="sidebarCollapsed"
        router
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#667eea"
      >
        <el-menu-item
          v-for="route in visibleRoutes"
          :key="route.name"
          :index="route.path"
        >
          <i :class="route.meta.icon"></i>
          <span slot="title">{{ $t(`route.${route.meta.title}`) }}</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <!-- Main Content -->
    <div class="admin-main">
      <!-- Header -->
      <header class="admin-header">
        <div class="header-left">
          <el-button
            type="text"
            :icon="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            @click="toggleSidebar"
          />
          <el-breadcrumb separator="/">
            <el-breadcrumb-item
              v-for="item in breadcrumbs"
              :key="item.path"
              :to="{ path: item.path }"
            >
              {{ $t(`route.${item.meta.title}`) || item.meta.title }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="header-right">
          <!-- Language Switcher -->
          <el-dropdown @command="changeLanguage">
            <span class="user-dropdown">
              {{ currentLanguage.toUpperCase() }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="en">English</el-dropdown-item>
              <el-dropdown-item command="ru">Русский</el-dropdown-item>
              <el-dropdown-item command="hy">Հայերեն</el-dropdown-item>
              <el-dropdown-item command="zh">中文</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- User Dropdown -->
          <el-dropdown @command="handleUserCommand">
            <span class="user-dropdown">
              <span class="avatar">{{ userInitials }}</span>
              <span>{{ currentUser?.name }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">
                <i class="el-icon-user"></i>
                Profile
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <i class="el-icon-switch-button"></i>
                Logout
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <!-- Page Content -->
      <main class="admin-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminLayout',
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    activeMenu() {
      return this.$route.path
    },
    visibleRoutes() {
      const routes = this.$router.options.routes.find(r => r.path === '/')?.children || []
      return routes.filter(r => !r.meta?.hidden)
    },
    breadcrumbs() {
      const matched = this.$route.matched.filter(r => r.meta?.title)
      return matched
    },
    currentLanguage() {
      return this.$i18n.locale
    },
    userInitials() {
      return this.currentUser?.name
        ?.split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2) || 'AD'
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('admin_lang', lang)
    },
    handleUserCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('logout').then(() => {
          this.$router.push('/login')
        })
      } else if (command === 'profile') {
        this.$router.push('/settings')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .logo-img {
    height: 28px;
    width: auto;
  }

  span {
    &:last-child {
      white-space: nowrap;
    }
  }
}
</style>
